import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '@env';
import { Res } from 'src/app/modules/client/services/res';
import { LoaderService } from '@shared/components/loader/loader.service';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';

declare const RBTracking;

@Injectable({
  providedIn: 'root'
})

export class TrackingService {

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private applymentModel: ApplymentModel,
  ) {
    //
  }

  getData(callbackSuccess, callbackError) {
    try {
      return RBTracking.getData(callbackSuccess,callbackError);
    } catch (error) {
      callbackError()
    }
  }

  loadTrackingScript() : void{
    const token = localStorage.getItem('token');
    this.http.post<Res>(`${environment.API}/tracking`, {
      url: localStorage.getItem('crm_domain_' + token )
    }).subscribe(
      res => {
        if (res.success) {
          this.setScriptIntoHtml(res.data);
        }
      },
      error => {
        console.error('error', error)
      }
    );
  }

  setScriptIntoHtml(script:string) : void {
    const token = localStorage.getItem('token');
    const elm = document.createElement('script');
    elm.type = 'text/javascript';
    elm.src = script.replace('<script type="text/javascript" src="', '').replace('"></script>', '');

    elm.onload = () => {
      this.getTrackingIdentify(token);
    };
    document.head.appendChild(elm);
  }

  checkTrackingAvailability() {
    return typeof RBTracking !== 'undefined'
  }

  loadTrackingScriptToClearSession() : void {
    this.loaderService.setChangesLoaderState(true);
    this.getSettings()
    .then((settings: any) => this.setDataInLocalStorage(settings.data))
    .then(() => this.requestTracking())
    .catch(error => this.loaderService.setChangesLoaderState(false, error.body, '', 'error', error.title, 100000))
    .then((trackingData) => {
      if (trackingData) {
        this.loaderService.setChangesLoaderState(false);
        this.setScriptIntoHtmlToClearSession(trackingData.data);
      }
    });
  }

  setScriptIntoHtmlToClearSession(script:string) : void {
    const token = localStorage.getItem('token');
    const elm = document.createElement('script');
    elm.type = 'text/javascript';
    elm.src = script.replace('<script type="text/javascript" src="', '').replace('"></script>', '');

    elm.onload = () => {
      setTimeout(() => {
        if (RBTracking.getHash()) {
          RBTracking.resetSession();
          this.getTrackingIdentify(token);
        }
      },20);
    };
    document.head.appendChild(elm);
  }

  clearTrackingSession() {
    if (RBTracking.getHash()) {
      RBTracking.resetSession();
    }
  }

  getTrackingIdentify(token:string, progress = 0):void {
    setTimeout(() => {
      if (RBTracking.getHash() && RBTracking.getVisitor()?.id) {
          localStorage.setItem('session_id_tracking_' + token, RBTracking.getHash());
          localStorage.setItem('hostClient_tracking_' + token, RBTracking.getHostClient());
          localStorage.setItem('substitute_id_tracking_' + token, RBTracking.idGenerator());
          localStorage.setItem('contact_crm_id_tracking_' + token, RBTracking.getVisitor().id);
      } else {
        if(progress <= 10) {
          this.getTrackingIdentify(token, ++progress);
        }
      }
    }, 1000);
  }

  public updateTrackingIdentify() {
    this.getTrackingIdentify(localStorage.getItem('token'));
  }

  public getTrackingInfo() {
    if (this.checkTrackingAvailability() && RBTracking.getHash() && RBTracking.getHash() !== '') {
      return {
        'session_id' : RBTracking.getHash(),
        'host_client' : RBTracking.getHostClient(),
        'substitute_id' : RBTracking.idGenerator(),
        'contact_crm' : RBTracking.getVisitor()?.id
      }
    } else {
      return {
        'session_id' : null,
        'host_client' : null,
        'substitute_id' : null,
        'contact_crm' : null
      }
    }
  }

  private setDataInLocalStorage(settingsData) {
    localStorage.setItem('token', settingsData.token);
    localStorage.setItem('crm_domain_' + settingsData.token , settingsData.crm_domain);
    return true;
  }

  private requestTracking() {
    const token = localStorage.getItem('token');
    return this.http.post<Res>(`${environment.API}/tracking`, {
      url: localStorage.getItem('crm_domain_' + token )
    }).toPromise();
  }

  private getSettings() {
    return this.http.post(`${environment.API}/applyment/settings`,
      {
        domain: this.applymentModel.getSettings().domain,
        token: null
      })
    .toPromise();
  }
}
